var $ = jQuery;

class FloatingLabel {

	constructor(WRAPPER_ELEMENT, INPUT_TYPE) {
		this.WRAPPER_ELEMENT = WRAPPER_ELEMENT;
		this.INPUT_TYPE = INPUT_TYPE;
		this.INPUT_SELECTOR = '.' + this.WRAPPER_ELEMENT.split(' ').join('.');
		this.INPUT_WRAPPERS = document.querySelectorAll(this.INPUT_SELECTOR);
		this.init();
	}

	init() {
		const WRAPPER_ELEMENT = this.WRAPPER_ELEMENT;

		if (this.INPUT_WRAPPERS) {
			for (let i = 0; i < this.INPUT_WRAPPERS.length; i++) {
				const INPUT_WRAP = this.INPUT_WRAPPERS[i];
				const INPUT = INPUT_WRAP.querySelector(this.INPUT_TYPE);

				if (INPUT.value) {
					const INPUT_WRAP_CLASSES = INPUT_WRAP.className;
					INPUT_WRAP.className = INPUT_WRAP_CLASSES + ' active';
				}

				if (INPUT.type === 'select-one' || INPUT.type === 'select-multiple') {
					INPUT.addEventListener('change', function () {
						console.log('changed')
						if (this.value) {
							INPUT_WRAP.className = WRAPPER_ELEMENT + ' active';
						} else {
							INPUT_WRAP.className = WRAPPER_ELEMENT;
						}
					});
				}
				// } else if (INPUT.getAttribute('name') === 'birthday') {

				// 	// For datepicker
				// 	$("[name=birthday]").on("change", function() {
				// 		if (this.value) {
				// 			INPUT_WRAP.className = WRAPPER_ELEMENT + ' active';
				// 		} else {
				// 			INPUT_WRAP.className = WRAPPER_ELEMENT;
				// 		}
				// 	});

				// } 
				else {
					INPUT.addEventListener('input', function () {
						if (this.value) {
							INPUT_WRAP.className = WRAPPER_ELEMENT + ' active';
						} else {
							INPUT_WRAP.className = WRAPPER_ELEMENT;
						}
					});
				}
			}
		}
	}
}

module.exports = FloatingLabel;